import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { WebTransaction } from "src/app/models";
import { TransactionsService } from "src/app/services/transactions-service";
import { CompanyService, CustomerService } from "../../services";
import { Router } from "@angular/router";
import { SessionDataService } from "src/app/services/session-data.service";
import { filter } from "rxjs/operators";
@Component({
    selector: "app-transactions",
    templateUrl: "./transactions.component.html",
    styleUrls: ["./transactions.component.scss"],
})

export class TransactionsComponent implements OnInit, OnDestroy
{


    branchCustId: string;
    isCompany: boolean;
    isEmployee: boolean = false;
    notesOption: number;
    noteStatus: string = 'Exclude Notes';
    displayExport: boolean = true;

    showAllRecords: boolean;
    numberOfRecords = 100;
    transactionList: WebTransaction[];
    transactionSubscription: Subscription;
    companySubscription: Subscription;

    constructor(
        public dialog: MatDialog,
        private transactionsService: TransactionsService,
        private customerService: CustomerService,
        private companyService: CompanyService,
        public router: Router,
        private sessionDataService: SessionDataService
    ) { }

    ngOnInit(): void
    {

        this.isEmployee = this.sessionDataService.IsEmployee;

        this.companySubscription = this.companyService.company.subscribe(c =>
        {
            if (c.WebDisplayTransactions === false && this.isEmployee == false)
            {
                this.router.navigate(["/not-found"]);
            }
        });

        this.transactionSubscription = this.transactionsService.recentTransactions.subscribe(t =>
        {
            this.transactionList = t;
        });
        this.setTransactionAndNoteVisibility();

    }

    selectNoteVisibility(status: string)
    {
        localStorage.setItem("Note Status", status);
        this.setTransactionAndNoteVisibility()
    }

    ngOnDestroy()
    {
        this.transactionSubscription.unsubscribe();
        this.companySubscription.unsubscribe();
    }

    setTransactionAndNoteVisibility()
    {
        this.noteStatus = localStorage.getItem("Note Status") === null ? "Exclude Notes" : localStorage.getItem("Note Status");

        if (this.noteStatus.toLowerCase() === "include notes" && this.isEmployee)
        {
            this.notesOption = 0
            this.displayExport = true;
        }
        else if (this.noteStatus.toLowerCase() === "notes only" && this.isEmployee)
        {
            this.notesOption = 2
            this.displayExport = false;
        }
        else
        {
            this.notesOption = 1
            this.displayExport = true;
        }
        this.getTransactions(this.numberOfRecords);
    }

    getTransactions(numberTransactions: number)
    {
        this.customerService.customer
            .pipe(filter(customer => !!customer))
            .subscribe(customer =>
            {
                this.branchCustId = customer.BranchCustId;
                this.transactionsService.getRecentHistory(this.branchCustId, numberTransactions, this.notesOption);
            });
    }

    getAllTransactions()
    {
        this.showAllRecords = !this.showAllRecords;
        this.getTransactions(null);
    }
}
